import { useReveal } from "@/hooks/useReveal";

export const WhyDuneworth = () => {
  const { ref, shown } = useReveal();
  return (
    <section
      data-testid="why-duneworth-section"
      className="relative bg-primary text-primary-foreground py-24 sm:py-32 overflow-hidden"
    >
      <div className="pointer-events-none absolute inset-0">
        <div className="absolute top-0 left-0 right-0 h-px bg-accent/30" />
        <div className="absolute -top-32 -left-32 h-[420px] w-[420px] rounded-full bg-accent/5 blur-3xl" />
      </div>

      <div
        ref={ref}
        className={`relative max-w-6xl mx-auto px-6 sm:px-8 lg:px-12 reveal ${
          shown ? "in" : ""
        }`}
      >
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-16 items-start">
          <div className="lg:col-span-5">
            <div className="flex items-center gap-4 mb-8">
              <span className="h-px w-10 bg-accent" />
              <span className="text-[11px] uppercase tracking-[0.32em] text-accent font-semibold">
                Why Duneworth
              </span>
            </div>
            <h2
              data-testid="why-headline"
              className="font-serif text-4xl sm:text-5xl lg:text-6xl leading-[1.05] tracking-tight text-balance"
            >
              Operator-led, <br className="hidden sm:block" />
              <em className="italic">not idea-led.</em>
            </h2>
          </div>

          <div className="lg:col-span-7 space-y-6">
            <p
              data-testid="why-body-1"
              className="text-lg sm:text-xl leading-relaxed text-primary-foreground/85 text-pretty"
            >
              Duneworth builds companies from the inside out. Strategy, product,
              design, monetization, partnerships, and capital are shaped
              together from day one — by the people who will own the outcome.
            </p>
            <p
              data-testid="why-body-2"
              className="text-base sm:text-lg leading-relaxed text-primary-foreground/65 text-pretty"
            >
              This is how each business moves faster, stays cleaner, and avoids
              the common failure points of early software companies: unclear
              positioning, weak monetization, fragmented systems, and shallow
              product-market understanding.
            </p>

            <div className="pt-8 grid grid-cols-2 sm:grid-cols-4 gap-6">
              {[
                "Strategy",
                "Product",
                "Operations",
                "Capital",
              ].map((item) => (
                <div
                  key={item}
                  className="border-t border-primary-foreground/20 pt-4"
                  data-testid={`why-discipline-${item.toLowerCase()}`}
                >
                  <p className="text-[11px] uppercase tracking-[0.3em] text-accent font-semibold">
                    {item}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyDuneworth;
